import img from "../img_us/22Salle de conférence équipée de stores intérieurs occultants pour protection solaire et confort visuel_imgupscaler.ai_B.webp";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsSolarStorePage() {

  useEffect(() => {
    // Animation
    AOS.init({
      duration: 1500,
      once: true,
    });

    // SEO
    document.title =
      "Stores solaires pour fenêtres et baies vitrées | Confort lumineux – UNIK SYSTEM";

    let meta = document.querySelector("meta[name='description']");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.setAttribute(
      "content",
      "Stores solaires techniques pour fenêtres et baies vitrées : protection contre l’éblouissement, gestion de la lumière et confort visuel pour espaces résidentiels et professionnels."
    );
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>SOLAR</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Stores solaires pour vitrages</h1>

          <p data-aos="fade-up">
            Toiles techniques pour habiller les fenêtres, baies vitrées et
            portes vitrées, permettant une gestion efficace de la lumière
            naturelle tout en améliorant le confort intérieur.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-solar-store.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Solar store pour vitrage" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US SOLAR Store ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US SOLAR Store est une solution de toiles techniques conçues
            pour habiller les fenêtres, baies vitrées et portes vitrées.
            Elle permet de contrôler la lumière naturelle tout en
            améliorant le confort visuel.
          </p>

          <p data-aos="fade-up">
            Ces stores solaires sont adaptés aux environnements
            résidentiels, commerciaux et professionnels, offrant
            protection, design et performance.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="☀️"
            title="Anti-éblouissement"
            text="Protection efficace contre la lumière directe du soleil."
          />
          <Feature
            icon="🌑"
            title="Capacité opacifiante"
            text="Gestion de la luminosité selon les besoins."
          />
          <Feature
            icon="🔇"
            title="Option acoustique"
            text="Propriétés acoustiques possibles selon les textiles."
          />
          <Feature
            icon="🎨"
            title="Design personnalisé"
            text="Large choix de couleurs et textures."
          />
          <Feature
            icon="⚡"
            title="Installation rapide"
            text="Pose simple et propre sans travaux lourds."
          />
          <Feature
            icon="🏢"
            title="Usage polyvalent"
            text="Adapté aux habitations, bureaux et commerces."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Toiles techniques solaires</li>
          <li>Gestion de la lumière naturelle</li>
          <li>Capacité opacifiante selon modèle</li>
          <li>Option textile acoustique</li>
          <li>Installation sur fenêtres et baies vitrées</li>
          <li>Large choix de couleurs et textures</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Habitations",
            "Bureaux",
            "Commerces",
            "Hôtels",
            "Salles de réunion",
            "Espaces publics",
            "Baies vitrées",
            "Façades vitrées",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Besoin d’un store solaire sur mesure ?</h2>
        <p>Nos équipes vous accompagnent dans votre projet.</p><br/>
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
